/**
 * Insta NFT × Shopify — storefront cart + shipping helper
 *
 * - Hydrates window.instaNftCheckoutData.shopify from GET /cart.js
 * - Quotes shipping from Shopify Shipping & delivery via
 *   GET /cart/shipping_rates.json and renders radios in #inc-nft-shipping-methods
 *   (checkout form, between Shipping Information and Card Information)
 * - Updates cart_total = products_total + selected shipping rate
 */
(function () {
  var ISO3_TO_ISO2 = {
    USA: 'US',
    CAN: 'CA',
    MEX: 'MX',
    GBR: 'GB',
    AUS: 'AU',
    NZL: 'NZ',
    DEU: 'DE',
    FRA: 'FR',
    ITA: 'IT',
    ESP: 'ES',
    NLD: 'NL',
    BRA: 'BR',
    IND: 'IN',
    JPN: 'JP',
    KOR: 'KR',
    CHN: 'CN',
    SGP: 'SG',
    ARE: 'AE',
    SAU: 'SA',
    ZAF: 'ZA',
    NGA: 'NG'
  };

  function moneyFromCents(cents) {
    var n = Number(cents);
    if (isNaN(n)) return 0;
    return Math.round(n) / 100;
  }

  function variantGid(variantId) {
    var s = String(variantId || '');
    if (s.indexOf('gid://') === 0) return s;
    return 'gid://shopify/ProductVariant/' + s;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function toIso2Country(country) {
    var raw = String(country || '').trim().toUpperCase();
    if (!raw) return '';
    if (raw.length === 2) return raw;
    return ISO3_TO_ISO2[raw] || raw.slice(0, 2);
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed to load cart (' + res.status + ')');
      return res.json();
    });
  }

  function mapCartItems(cart) {
    var items = cart && cart.items ? cart.items : [];
    return items.map(function (item) {
      return {
        variant_id: item.variant_id,
        variant_gid: variantGid(item.variant_id),
        quantity: item.quantity,
        title: item.title || item.product_title,
        sku: item.sku || '',
        price: item.price,
        line_price: item.line_price,
        original_line_price: item.original_line_price,
        properties: item.properties || {},
        requires_shipping: !!item.requires_shipping,
        product_id: item.product_id,
        key: item.key
      };
    });
  }

  var DRAFT_SESSION_KEY = 'inc_shopify_nft_checkout';

  function readDraftSession() {
    try {
      var raw = localStorage.getItem(DRAFT_SESSION_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function hydrateCheckoutData(cart) {
    if (!window.instaNftCheckoutData) window.instaNftCheckoutData = {};
    var checkout = window.instaNftCheckoutData;
    var prev = checkout.shopify || {};
    checkout.site_type = checkout.site_type || 'shopify';
    checkout.products_total = moneyFromCents(cart.total_price);
    checkout.cart_total = moneyFromCents(cart.total_price);

    var session = readDraftSession() || {};
    var draft_order_id = '';
    if (
      session.draft_order_id &&
      (!session.cart_token || session.cart_token === cart.token)
    ) {
      draft_order_id = session.draft_order_id;
    } else if (prev.draft_order_id && prev.cart_token === cart.token) {
      draft_order_id = prev.draft_order_id;
    }

    checkout.shopify = {
      cart_token: cart.token,
      draft_order_id: draft_order_id,
      shop: prev.shop || '',
      currency: cart.currency || prev.currency || 'USD',
      items: mapCartItems(cart),
      total_price: cart.total_price
    };

    var methods = document.getElementById('inc-nft-shipping-methods');
    if (methods) {
      methods.setAttribute('data-products-cents', String(cart.total_price || 0));
      methods.setAttribute(
        'data-currency',
        cart.currency || methods.getAttribute('data-currency') || 'USD'
      );
    }
  }

  function getShippingUi() {
    var methods = document.getElementById('inc-nft-shipping-methods');
    if (!methods) return null;

    var productsCents = Number(methods.getAttribute('data-products-cents') || 0);
    if (!isFinite(productsCents)) productsCents = 0;

    return {
      methods: methods,
      currency:
        methods.getAttribute('data-currency') ||
        (window.instaNftCheckoutData &&
          window.instaNftCheckoutData.shopify &&
          window.instaNftCheckoutData.shopify.currency) ||
        'USD',
      productsTotal: productsCents / 100
    };
  }

  function formatMoney(amount, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD'
      }).format(amount);
    } catch (e) {
      return '$' + Number(amount).toFixed(2);
    }
  }

  function setShippingStatus(html, isError) {
    var ui = getShippingUi();
    if (!ui) return;
    ui.methods.innerHTML =
      '<p class="insta-shopify-nft__ship-' +
      (isError ? 'error' : 'status') +
      '">' +
      html +
      '</p>';
    applyShippingSelection(null);
  }

  function applyShippingSelection(preferredHandle) {
    var ui = getShippingUi();
    if (!ui) return;

    var checked = ui.methods.querySelector(
      'input[name="inc_nft_shipping_method"]:checked'
    );
    if (!checked && preferredHandle) {
      checked = ui.methods.querySelector(
        'input[name="inc_nft_shipping_method"][value="' +
          preferredHandle.replace(/"/g, '') +
          '"]'
      );
      if (checked) checked.checked = true;
    }

    var shippingPrice = checked ? Number(checked.getAttribute('data-price') || 0) : 0;
    if (!isFinite(shippingPrice) || shippingPrice < 0) shippingPrice = 0;

    var title = checked ? String(checked.getAttribute('data-title') || 'Shipping') : '';
    var handle = checked ? String(checked.value || '') : '';
    var grandTotal = ui.productsTotal + shippingPrice;

    ui.methods.querySelectorAll('.insta-shopify-nft__ship-option').forEach(function (label) {
      var radio = label.querySelector('input[type="radio"]');
      label.classList.toggle('is-selected', !!(radio && radio.checked));
    });

    var shippingEl = document.getElementById('inc-nft-shipping-amount');
    var grandEl = document.getElementById('inc-nft-grand-total');
    var toggleEl = document.getElementById('inc-nft-toggle-total');
    var productsEl = document.getElementById('inc-nft-products-total');

    if (productsEl) productsEl.textContent = formatMoney(ui.productsTotal, ui.currency);
    if (shippingEl) {
      shippingEl.textContent = !checked
        ? 'Calculated at next step'
        : shippingPrice === 0
          ? 'Free'
          : formatMoney(shippingPrice, ui.currency);
    }
    if (grandEl) grandEl.textContent = formatMoney(grandTotal, ui.currency);
    if (toggleEl) toggleEl.textContent = formatMoney(grandTotal, ui.currency);

    if (!window.instaNftCheckoutData) window.instaNftCheckoutData = {};
    window.instaNftCheckoutData.products_total = ui.productsTotal;
    window.instaNftCheckoutData.cart_total = grandTotal;
    window.instaNftCheckoutData.shopify = window.instaNftCheckoutData.shopify || {};
    window.instaNftCheckoutData.shopify.currency = ui.currency;

    if (checked) {
      window.instaNftCheckoutData.shopify.shipping_line = {
        handle: handle,
        title: title,
        price: shippingPrice
      };
    } else if (window.instaNftCheckoutData.shopify.shipping_line) {
      delete window.instaNftCheckoutData.shopify.shipping_line;
    }

    window.dispatchEvent(
      new CustomEvent('inc-nft-shipping-change', {
        detail: {
          products_total: ui.productsTotal,
          shipping_rate: checked ? shippingPrice : null,
          cart_total: grandTotal,
          currency: ui.currency,
          shipping_line: checked
            ? { handle: handle, title: title, price: shippingPrice }
            : null,
          rates_count: ui.methods.querySelectorAll(
            'input[name="inc_nft_shipping_method"]'
          ).length
        }
      })
    );
  }

  function renderShippingRates(rates) {
    var ui = getShippingUi();
    if (!ui) return;

    if (!rates.length) {
      setShippingStatus('No shipping rates available for this address.', false);
      return;
    }

    var prevHandle =
      (window.instaNftCheckoutData &&
        window.instaNftCheckoutData.shopify &&
        window.instaNftCheckoutData.shopify.shipping_line &&
        window.instaNftCheckoutData.shopify.shipping_line.handle) ||
      '';

    var html = '<div class="insta-shopify-nft__ship-title">Shipping method</div>';
    rates.forEach(function (rate, index) {
      var handle = String(rate.handle || rate.code || rate.name || 'rate-' + index);
      var title = String(rate.title || rate.name || 'Shipping');
      var price = Number(rate.price);
      if (!isFinite(price) || price < 0) price = 0;
      var selected =
        (prevHandle && prevHandle === handle) || (!prevHandle && index === 0);

      html +=
        '<label class="insta-shopify-nft__ship-option' +
        (selected ? ' is-selected' : '') +
        '">' +
        '<input type="radio" name="inc_nft_shipping_method" value="' +
        escapeHtml(handle) +
        '" data-title="' +
        escapeHtml(title) +
        '" data-price="' +
        price +
        '"' +
        (selected ? ' checked' : '') +
        '>' +
        '<span class="insta-shopify-nft__ship-option-body">' +
        '<span>' +
        escapeHtml(title) +
        '</span><span>' +
        (price === 0 ? 'Free' : formatMoney(price, ui.currency)) +
        '</span></span></label>';
    });

    ui.methods.innerHTML = html;
    applyShippingSelection(prevHandle || null);
  }

  function mapStorefrontRates(payload) {
    var list = (payload && payload.shipping_rates) || [];
    return list.map(function (rate, index) {
      return {
        handle: String(rate.code || rate.source + '-' + rate.name || 'rate-' + index),
        title: String(rate.name || 'Shipping'),
        price: Number(rate.price) || 0,
        code: rate.code || '',
        source: rate.source || ''
      };
    });
  }

  var quoteSeq = 0;

  function quoteShipping(address) {
    var ui = getShippingUi();
    if (!ui) return Promise.resolve([]);

    if (!address || !address.country || (!(address.zip || '').trim() && !(address.city || '').trim())) {
      setShippingStatus('Enter your address to see shipping options from this store.', false);
      return Promise.resolve([]);
    }

    var country = toIso2Country(address.country);
    if (!country) {
      setShippingStatus('Enter your address to see shipping options from this store.', false);
      return Promise.resolve([]);
    }

    var params = new URLSearchParams();
    params.set('shipping_address[country]', country);
    if ((address.zip || '').trim()) {
      params.set('shipping_address[zip]', String(address.zip).trim());
    }
    if ((address.state || '').trim()) {
      params.set('shipping_address[province]', String(address.state).trim());
    }
    if ((address.city || '').trim()) {
      params.set('shipping_address[city]', String(address.city).trim());
    }

    var seq = ++quoteSeq;
    setShippingStatus('Calculating shipping…', false);

    return fetch('/cart/shipping_rates.json?' + params.toString(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, status: res.status, data: data };
        });
      })
      .then(function (result) {
        if (seq !== quoteSeq) return [];

        if (!result.ok) {
          var message =
            (result.data && (result.data.message || result.data.description)) ||
            'Could not load shipping rates for this address.';
          setShippingStatus(escapeHtml(message), true);
          return [];
        }

        var rates = mapStorefrontRates(result.data);
        renderShippingRates(rates);
        return rates;
      })
      .catch(function (err) {
        if (seq !== quoteSeq) return [];
        setShippingStatus(
          escapeHtml((err && err.message) || 'Could not load shipping rates.'),
          true
        );
        return [];
      });
  }

  window.incShopifyFetchCart = fetchCart;
  window.incShopifyQuoteShipping = quoteShipping;

  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (target && target.name === 'inc_nft_shipping_method') {
        applyShippingSelection(target.value);
      }
    });

    window.addEventListener('inc-nft-shipping-address', function (event) {
      quoteShipping(event.detail || null);
    });

    fetchCart()
      .then(hydrateCheckoutData)
      .catch(function (err) {
        if (window.console && console.error) console.error(err);
      });
  });
})();
